import { useEffect, useMemo, useState } from 'react';
import { useTranslations } from '../../../hooks/translations';
import { useMinimalSearchLazyQuery, useSearchLazyQuery } from './useSearchLazyQuery';

export function useCurriculumDetailsQuery( curriculumId, options ) {

    const { locale } = useTranslations();

    // Query for the details for a single curriculum.
    const [ searchQuery, { data: rawData, loading, error, enrollments: enrollmentsData, pageData  } ] = useSearchLazyQuery( {}, false );
    const [ minSearchQuery, { data: minData, loading: minLoading } ] = useMinimalSearchLazyQuery();
    const [ customError, setCustomError ] = useState( null );

    async function fetch() {
        searchQuery( {
            types: [ 'curricula' ],
            ids: [ curriculumId ],
            query: '',
            page: 1,
            limit: 1, 
        } );
    }

    async function minFetch() {

        await minSearchQuery( {
            types: [ 'curricula' ],
            ids: [ curriculumId ],
            query: '',
            page: 1,
            limit: 1, 
        } );
    }

    const [ refinedData, setRefinedData ] = useState( null );

    // initial fetch
    useEffect( () => {
        fetch();
    }, [ locale ] );

    // after fetch: set data or do minfetch
    useEffect( () => {
        if ( rawData == null || !enrollmentsData ) {return;}

        if ( pageData.totalResults === 0 ) {
            // you cant see this curriculum
            minFetch();
        } else if ( rawData.length > 0 ) {
            setRefinedData( rawData[ 0 ] );
        }


    }, [ rawData, enrollmentsData ] );

    // after minfetch: show error and possible set data
    useEffect( () => {
        
        if ( minData == null ) {return;} // if the normal search hasnt even occured, dont do minstuff

        if ( minData.length > 0 ) {
            // this curriculum exists but you cant see it
            setCustomError( {
                titleKey: 'error.noPermission.title',
                descriptionKey: 'error.noPermission.description',
            } );
            setRefinedData( minData[ 0 ] );
        } else {
            // this curriculum does not exist
            setCustomError( {
                titleKey: 'error.curriculum.DNE.title',
                descriptionKey: 'error.curriculum.DNE.description',
            } );
        }
    }, [ minData ] );

    return useMemo ( () => {
        return {
            error: customError ?? error,
            loading: loading || minLoading,
            data: refinedData,
            refetch: fetch,
        };
    }, [ refinedData, loading, error, customError, minLoading ] );
}
